import { createSelector } from 'reselect'
import { IDispatcherState } from 'apps/fleet-planner/types'
import { IStore } from 'apps/fleet-planner/utils/types/store'

const dispatchersStateSelector = (state: IStore): IDispatcherState => state.dispatchers

export const dispatchersListSelector = createSelector(
  dispatchersStateSelector,
  ({ dispatchers }) => dispatchers
)
